import React, { Component } from "react";
import { Card, Button, Col, Row } from "react-bootstrap";
import css from "../../pages/Assessments/StudentAssessments/student-assessments.module.scss";
import { HelpfulButton } from "components";
import { MainContainer } from "pages/Main";
import {
  Breadcrumb,
  CardGrid,
  JustifyBetween,
  OverlayTooltip,
  Select,
  Toolbar,
  ToolbarSort,
} from "components";
import * as config from "config";
import { Link } from "react-router-dom";
import CardAssessment from "pages/Assessments/CardAssessment/CardAssessment";
import { withApiContext, withLabelsContext, withUserContext } from "context";
import MediaPickerPagination from "components/ModuleInput/MediaPicker/Pagination/index";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import MediaQuery from "react-responsive";
import RubricsCard from "./RubricsCard";

const dateTimeFormat = (s0, s1) => {
    var pattern = /(\d{2})\-(\d{2})\-(\d{4})/;
    var date = new Date(s0.replace(pattern, "$3-$2-$1"));
    // date === "Invalid Date" ? alert(date + ":  " + s0 + ":  " + s1) : null
    return date;
  };
class StudentRubricsAssessment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: "sequence",
      sortBase: "asc",
      disable: false,
      filter: this.props.location.filter ? this.props.location.filter : config.assessmentFilterList[4].value,
      rubrics: {},
      isAssessmentLoaded: false,
      rubricsNotExist: true,
      surveyDetails: "",
      fromSurvey: false,
      pageIndex: 1,
      cardsPerPage : 8,
      surveyExist : null,
      a_date:""
    };
  }

  componentDidMount = () => { 
    this.getRubricsAssessments();
};

  filterChange = (selectedOption) => {
    this.setState({ filter: selectedOption,pageIndex:1 });
  };

  handleType = (obj) => {
    this.setState({ sort: obj.type, sortBase: obj.order });
  };

  mkPublishItem = (row) => {
    const id = row.id ?? row.rubrics_assessment_id;
    if (!id) {
      return null;
    }
    return {
      id,
      name: row.name ?? "",
      currName: row.curriculum_name ?? "",
      currTitle:
        row.curriculum_name ??
        row.short_name ??
        `Common ${this.props.ctx_labels.singular.assessment.toLowerCase()} assessment`,
      date:row.start_date ?? "",
      status: row.rubric_status || "Yet to Start",
      score: "",
      endDate: row.due_date ?? "",
      endDateOriginal:  row.to_date_original ?? "",
      startDateoriginal:  row.from_date_original ?? "",
      pending: 0,
      reassign: 0,
      reassignDate: null,
      survey: row,
      description: row.description ?? "",
      newEndDate:  row.new_due_date ?? "",
      newStartDate: row.new_start_date ?? "",
      action: row.created_on ?? "",
      submittedOn: null,
    };
  };

  getRubricsAssessments = () => {
    this.setState({ isAssessmentLoaded: false });
    const args = {};
    if (this.props?.ctx_user?.user?.classId) {
      args.classId = this.props.ctx_user.user.classId;
    }
    return this.props.ctx_api
      .privateRequest({
        cmd: "get_rubrics_assessments_list",
        args,
      })
      .then(({ rsp }) => {
        const list = Array.isArray(rsp) ? rsp : [];
        const items = {};
        list.forEach((row) => {
          const item = this.mkPublishItem(row);
          if (item) {
            items[item.id] = item;
          }
        });
        this.setState({
          rubrics: items,
          rubricsNotExist: list.length === 0,
          surveyDetails: list,
          fromSurvey: false,
          isAssessmentLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ isAssessmentLoaded: true });
      });
  };

  
  handlePaginationChange = (newPageIndex) => {
    this.setState({ pageIndex: newPageIndex });
  };
  

  render() {
    let Rubricspage = [];
    const rubricList = Object.values(this.state.rubrics);
    const { pageIndex, cardsPerPage } = this.state;
    const startIndex = (pageIndex - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const hasRubricsToPaginate = rubricList.length > 0;
    const rubricsFilter1 =
      rubricList.length < 1 &&
      (this.state.filter === "closed" ||
        this.state.filter === "yettostart" ||
        this.state.filter === "inprogress" ||
        this.state.filter === "attended" ||
        this.state.filter === null);
    const rubricsData1 = rubricList.map((itm) => {
      const status = itm.survey?.rubric_status || "";
      return (
        (this.state.filter === "closed" && status !== "Closed") ||
        (this.state.filter === "attended" && status !== "Attended") ||
        (this.state.filter === "yettostart" && status !== "Yet to Start") ||
        (this.state.filter === "inprogress" && status !== "In Progress") ||
        (this.state.filter === null && status !== "")
      );
    });
    const filteredRubricsList = rubricList.filter((itm) => {
      const status = itm.survey?.rubric_status || "";
      const filter = this.state.filter;
      
      // Handle null, undefined, or empty string filter
      if (!filter || filter === "" || filter === null) {
        return status === "In Progress" || !status;
      }
      
      switch (filter) {
        case "closed":
          return status === "Closed";
        case "attended":
          return status === "Attended";
        case "yettostart":
          return status === "Yet to Start";
        case "inprogress":
          return status === "In Progress";
        case "all":
          return status === "In Progress" || status === "Attended" || status === "Closed" || status === "Yet to Start";
        default:
          // For any other filter value, show all
          return true;
      }
    });
    
    const rubricsDataFilter = rubricsData1.every((itm) => itm == true);
    
    // Sort the filtered list
    filteredRubricsList.sort((a, b) => dateTimeFormat(b.newStartDate) - dateTimeFormat(a.newStartDate));
    switch (this.state.sort) {
      case "name":
        this.state.sortBase === "asc"
          ? filteredRubricsList.sort((a, b) => a.name.localeCompare(b.name))
          : filteredRubricsList.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "subject":
        this.state.sortBase === "asc"
          ? filteredRubricsList.sort((a, b) =>
              a.currTitle.localeCompare(b.currTitle)
            )
          : filteredRubricsList.sort((a, b) =>
              b.currTitle.localeCompare(a.currTitle)
            );
        break;
      case "start":
        this.state.sortBase === "asc"
          ? filteredRubricsList.sort(
              (a, b) =>
                dateTimeFormat(a.newStartDate) -
                dateTimeFormat(b.newStartDate)
            )
          : filteredRubricsList.sort(
              (a, b) =>
                dateTimeFormat(b.newStartDate) -
                dateTimeFormat(a.newStartDate)
            );
        break;
      case "end":
        this.state.sortBase === "asc"
          ? filteredRubricsList.sort(
              (a, b) =>
                dateTimeFormat(a.newEndDate) -
                dateTimeFormat(b.newEndDate)
            )
          : filteredRubricsList.sort(
              (a, b) =>
                dateTimeFormat(b.newEndDate) -
                dateTimeFormat(a.newEndDate)
            );
        break;
      default:
        filteredRubricsList.sort((a, b) => (a.sequence || 0) - (b.sequence || 0));
        break;
    }

    return (
      <MainContainer>
        <div style={{position:"relative"}}>
        <Breadcrumb list={[{ title: "Student Rubrics", current: true }]} />

        <JustifyBetween breakpoint="lg" alignItems="center">
          <div className="mb-3 mr-lg-3 ml-lg-0">
            <span className="text-primary fw-medium">Filtered by: </span>
            <i className="text-gray">
              {
                <span className="page-sub-title highligted">
                  {" "}
                  {this.state.filter === "attended"
                    ? "Attended"
                    : this.state.filter === "closed"
                    ? "Closed"
                    : this.state.filter === "inprogress"
                    ? "In Progress"
                    : this.state.filter === "yettostart"
                    ? "Yet To Start"
                    : this.state.filter === ""
                    ? "In Progress"
                    : ""}
                </span>
              }
            </i>
          </div>
          <div style={{ position: "relative", zIndex: 1000 }}>
            <Toolbar>	
              <Toolbar.Item>	
                <ToolbarSort	
                  onSelectType={this.handleType}	
                  options={config.assessmentSortList}	
                />	
              </Toolbar.Item>	
              <MediaQuery minDeviceWidth={768}>
                <Toolbar.Item style={{ minWidth: "130px", position: "relative", zIndex: 1001 }}>	
                  <Select	
                    options={config.assessmentFilterList}	
                    onChange={this.filterChange}	
                    value={this.state.filter}	
                    required={true}
                  />	
              </Toolbar.Item>	
              </MediaQuery>
              <MediaQuery maxDeviceWidth={767}>
                <Toolbar.Item style={{ minWidth: "130px", marginTop: "12px", position: "relative", zIndex: 1001 }}>	
                  <Select	
                    options={config.assessmentFilterList}	
                    onChange={this.filterChange}	
                    value={this.state.filter}	
                    required={true}
                  />	
              </Toolbar.Item>	
              </MediaQuery>
              
            </Toolbar>
          </div>

        </JustifyBetween>
        <div className="mb-4" style={{ position: "relative", zIndex: 1 }}></div>
        
        <CardGrid style={{ position: "relative", zIndex: 1 }}>
  {filteredRubricsList
    .slice(startIndex, endIndex)
    .map((itm, index) => {
      Rubricspage.push(index)
      const tip =
        itm.pending === 1
          ? `One or more ${this.props.ctx_labels.singular.assessment.toLowerCase()} pending`
          : "";
      return (
        <CardGrid.Item key={itm.id}>
          <OverlayTooltip
            tipId={index}
            tip={tip}
            disabled={true}
            placement="top"
          >
            {itm.survey.rubric_status === "Attended"  ? (
              <Link
                to={{
                  pathname: config.ROUTES.StudentRubricAttended,
                  state: {
                    rubrics: itm.survey,
                    fromSurvey: this.state.fromSurvey,
                    from: "rubrics",
                    filter: this.state.filter,
                  },
                }}
              >
                <RubricsCard
                  className={itm.pending === 1 ? css.disabled : ""}
                  {...itm}
                />
              </Link>
            ) : (
              <Link
                to={{
                  pathname:
                    itm.survey.rubric_status ===  "Closed" ? "" : config.ROUTES.StudentRubricDetails,
                  state: {
                    rubrics: itm.survey,
                    fromSurvey: this.state.fromSurvey,
                    from: "rubrics",
                    filter: this.state.filter,
                  },
                }}
              >
                <RubricsCard
                  className={itm.pending === 1 ? css.disabled : ""}
                  {...itm}
                />
              </Link>
            )}
          </OverlayTooltip>
        </CardGrid.Item>
      );
    })}
</CardGrid>
{hasRubricsToPaginate && Rubricspage.length > 0 &&(
        <MediaPickerPagination 
        key={pageIndex}
          onChange={this.handlePaginationChange}
          pageIndex={pageIndex}
          pageSize={cardsPerPage}
          totalCount={filteredRubricsList.length}
          fromSurvey
         
        />
      )}


       
        {(this.state.rubricsNotExist ||rubricsDataFilter ||rubricsFilter1) && (
          <h4>
            {this.props.ctx_labels.singular.rubricsAvailable.toLowerCase()}
          </h4>
        )}
        </div>
      </MainContainer>
    );
  }
}

export default withUserContext(
    withApiContext(withLabelsContext(withRouter(StudentRubricsAssessment)))
  );
